import { render, staticRenderFns } from "./CensusUploadRules.vue?vue&type=template&id=c950795e&scoped=true"
import script from "./CensusUploadRules.vue?vue&type=script&lang=ts"
export * from "./CensusUploadRules.vue?vue&type=script&lang=ts"
import style0 from "./CensusUploadRules.vue?vue&type=style&index=0&id=c950795e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950795e",
  null
  
)

export default component.exports